export const spanishCrmMessages = {
  crm: {
    action: { reset_password: "Restablecer contraseña" },
    auth: {
      first_name: "Nombre",
      last_name: "Apellido",
      confirm_password: "Confirmar contraseña",
      confirmation_required:
        "Sigue el enlace que te enviamos por correo para confirmar tu cuenta.",
      recovery_email_sent:
        "Si eres un usuario registrado, recibirás pronto un correo para recuperar tu contraseña.",
      sign_in_failed: "No fue posible iniciar sesión.",
      sign_in_google: "Continuar con Google",
      sign_in_google_workspace: "Continuar con Google Workspace",
      signup: {
        create_account: "Crear cuenta",
        create_first_user:
          "Crea la primera cuenta de usuario para completar la configuración.",
        creating: "Creando...",
        initial_user_created: "Usuario inicial creado correctamente",
      },
      welcome_title: "BaskervilleAI CRM",
    },
    common: {
      activity: "Actividad",
      added: "agregó",
      details: "Detalles",
      last_activity_with_date: "última actividad %{date}",
      load_more: "Cargar más",
      misc: "Información adicional",
      past: "Anteriores",
      read_more: "Leer más",
      retry: "Reintentar",
      show_less: "Mostrar menos",
      copied: "¡Copiado!",
      copy: "Copiar",
      loading: "Cargando...",
      me: "Yo",
      task_count: "%{smart_count} tarea |||| %{smart_count} tareas",
    },
    changelog: { title: "Novedades" },
    activity: {
      added_company: "%{name} agregó una empresa",
      you_added_company: "Agregaste una empresa",
      added_contact: "%{name} agregó un contacto",
      you_added_contact: "Agregaste un contacto",
      added_note: "%{name} agregó una nota sobre",
      you_added_note: "Agregaste una nota sobre",
      added_note_about_deal: "%{name} agregó una nota sobre la oportunidad",
      you_added_note_about_deal: "Agregaste una nota sobre la oportunidad",
      added_deal: "%{name} agregó una oportunidad",
      you_added_deal: "Agregaste una oportunidad",
      at_company: "en",
      to: "a",
      load_more: "Cargar más actividad",
    },
    dashboard: {
      deals_chart: "Ingresos próximos por oportunidades",
      deals_pipeline: "Pipeline de oportunidades",
      latest_activity: "Actividad reciente",
      latest_activity_error: "Error al cargar la actividad reciente",
      latest_notes: "Mis notas recientes",
      latest_notes_added_ago: "agregada %{timeAgo}",
      stepper: {
        install: "Instalar BaskervilleAI CRM",
        progress: "%{step}/3 completados",
        whats_next: "¿Qué sigue?",
      },
      upcoming_tasks: "Próximas tareas",
    },
    header: { import_data: "Importar datos" },
    image_editor: {
      change: "Cambiar",
      drop_hint: "Arrastra un archivo o haz clic para seleccionarlo.",
      editable_content: "Contenido editable",
      title: "Subir y ajustar imagen",
      update_image: "Actualizar imagen",
    },
    import: {
      action: {
        download_error_report: "Descargar informe de errores",
        import: "Importar",
        import_another: "Importar otro archivo",
      },
      error: { unable: "No se pudo importar este archivo." },
      idle: {
        description_1:
          "Puedes importar usuarios, empresas, contactos, notas y tareas.",
        description_2:
          "Los datos deben estar en un archivo JSON con el formato del siguiente ejemplo:",
      },
      status: {
        all_success: "Todos los registros se importaron correctamente.",
        complete: "Importación terminada.",
        failed: "Fallidos",
        imported: "Importados",
        in_progress: "Importación en curso. No salgas de esta página.",
        some_failed: "Algunos registros no se importaron.",
        table_caption: "Estado de la importación",
      },
      title: "Importar datos",
    },
    settings: {
      about: "Acerca de",
      companies: { sectors: "Sectores" },
      dark_mode_logo: "Logotipo para modo oscuro",
      deals: {
        categories: "Categorías",
        currency: "Moneda",
        pipeline_help:
          "Selecciona las etapas que deben contar como oportunidades activas en el pipeline.",
        pipeline_statuses: "Estados del pipeline",
        stages: "Etapas",
      },
      light_mode_logo: "Logotipo para modo claro",
      notes: { statuses: "Estados" },
      reset_defaults: "Restablecer valores predeterminados",
      save_error: "No se pudo guardar la configuración",
      saved: "Configuración guardada correctamente",
      saving: "Guardando...",
      tasks: { types: "Tipos" },
      preferences: "Preferencias",
      title: "Configuración",
      app_title: "Nombre de la aplicación",
      sections: { branding: "Marca" },
      validation: {
        duplicate: "%{display_name} duplicados: %{items}",
        in_use:
          "No se pueden quitar %{display_name} que todavía usan las oportunidades: %{items}",
        validating: "Validando...",
        entities: { categories: "categorías", stages: "etapas" },
      },
    },
    theme: {
      dark: "Oscuro",
      label: "Tema",
      light: "Claro",
      system: "Sistema",
    },
    language: "Idioma",
    navigation: { label: "Navegación del CRM", more: "Más" },
    profile: {
      inbound: {
        description:
          "Puedes enviar correos a la dirección de entrada de tu servidor, por ejemplo agregándola al campo %{field}. BaskervilleAI CRM procesará los correos y agregará notas a los contactos correspondientes.",
        title: "Correo entrante",
      },
      mcp: {
        title: "Servidor MCP",
        description:
          "Usa esta URL para conectar tu asistente de IA con los datos del CRM mediante el Protocolo de Contexto de Modelo (MCP).",
      },
      password: { change: "Cambiar contraseña" },
      password_reset_sent: "Se envió un correo para restablecer la contraseña",
      record_not_found: "No se encontró el registro",
      title: "Perfil",
      updated: "Tu perfil se actualizó correctamente",
      update_error: "Ocurrió un error. Inténtalo nuevamente.",
    },
    validation: {
      invalid_url: "Debe ser una URL válida",
      invalid_linkedin_url: "La URL debe pertenecer a linkedin.com",
    },
  },
  "ra-supabase": {
    auth: {
      email: "Correo electrónico",
      confirm_password: "Confirmar contraseña",
      sign_in_with: "Iniciar sesión con %{provider}",
      forgot_password: "¿Olvidaste tu contraseña?",
      reset_password: "Restablecer contraseña",
      password_reset: "Revisa tu correo para restablecer la contraseña.",
      missing_tokens: "Faltan los tokens de acceso y actualización",
      back_to_login: "Volver al inicio de sesión",
    },
    reset_password: {
      forgot_password: "¿Olvidaste tu contraseña?",
      forgot_password_details:
        "Ingresa tu correo para recibir un enlace de recuperación.",
    },
    set_password: {
      new_password: "Elige tu contraseña",
    },
    validation: {
      password_mismatch: "Las contraseñas no coinciden",
    },
    oauth: {
      no_request: "No se encontró una solicitud de autorización",
      approved: "Autorización aprobada",
      close_tab: "Ya puedes cerrar esta pestaña.",
      authorize: "Autorizar aplicación",
      authorize_details: "Esta aplicación solicita acceso a tu cuenta",
      permissions: "Permisos solicitados",
    },
  },
} as const;
